import { useState, useEffect } from "react";
import ThemeToggle from "@/components/feature/ThemeToggle";
import { useIsDarkPage, getThemedHref } from "@/hooks/useThemedHref";
import { navigation } from "@/content";

export default function LeanNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const isDark = useIsDarkPage();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = navigation.lean.links;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-stone-200/80 dark:bg-[#0A0A0A]/85 dark:border-white/[0.09] shadow-[0_1px_3px_rgba(0,0,0,0.04)]"
          : "bg-[#FAFAF8]/80 backdrop-blur-sm border-b border-transparent dark:bg-[#0A0A0A]/60"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16 md:h-20">
        <a href={getThemedHref("/lean", isDark)} className="flex items-center gap-2.5 cursor-pointer">
          <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-orange-600 dark:bg-orange-500">
            <i className="ri-settings-3-line text-white text-sm dark:text-[#0A0A0A]"></i>
          </div>
          <span className="font-extrabold text-lg tracking-tight text-stone-900 dark:text-white">
            {navigation.lean.logo.name}
            <span className="text-orange-600 dark:text-orange-500">{navigation.lean.logo.suffix}</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors cursor-pointer whitespace-nowrap dark:text-white/60 dark:hover:text-white"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={getThemedHref("/", isDark)}
            className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors cursor-pointer whitespace-nowrap dark:text-white/60 dark:hover:text-white"
          >
            Быстренко.ру
          </a>
          <ThemeToggle />
          <a
            href="#contact"
            className="text-sm font-bold px-5 py-2.5 rounded-full bg-orange-600 text-white hover:bg-orange-700 dark:bg-orange-500 dark:text-[#0A0A0A] dark:hover:bg-orange-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            {navigation.lean.cta.label}
          </a>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl text-stone-800 dark:text-white/80`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-t border-stone-100 dark:bg-[#0C0C0E]/95 dark:border-white/[0.08] px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-stone-700 font-medium text-sm cursor-pointer dark:text-white/70"
            >
              {link.label}
            </a>
          ))}
          <a
            href={getThemedHref("/", isDark)}
            onClick={() => setMenuOpen(false)}
            className="text-stone-600 font-medium text-sm cursor-pointer dark:text-white/60"
          >
            Быстренко.ру
          </a>
          <ThemeToggle />
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="mt-2 text-center text-sm font-bold px-5 py-3 rounded-full bg-orange-600 text-white cursor-pointer dark:bg-orange-500 dark:text-[#0A0A0A] whitespace-nowrap"
          >
            {navigation.lean.cta.label}
          </a>
        </div>
      )}
    </nav>
  );
}